<template>
  <div @click="routerPush" class="body-card">
    <div class="image-reviews-container mr-10">
      <img
        @error="handleImageError()"
        class="image"
        :src="banner"
        :alt="banner"
      />
    </div>
    <div class="content" style="cursor: pointer">
      <p class="facility-name m-0  c-caption">
        {{ title }}
      </p>
      <p class="c-tiny des-facility mt-5">
        {{ excerpt }}
      </p>
    </div>
  </div>
</template>

<script>
import { getBackGround } from "../../../utils/wapAuth";

export default {
  bodyClass: "card-facilities",
  components: {},
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      default: ""
    },
    excerpt: {
      default: ""
    },
    banner: {
      default:
        "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png"
    },
    id: {
      default: ""
    }
  },
  watch: {},
  data() {
    return {
      bg: getBackGround()
    };
  },
  computed: {},
  methods: {
    routerPush() {
      return this.$router.push(`/tin-tuc/chi-tiet/${this.id}`);
    },
    handleImageError() {
      return "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png";
    }
  }
};
</script>
<style lang="scss"></style>

<style scoped lang="scss">
.mr-10 {
  margin-right: 10px;
}

.content {
  max-width: 300px;
}

.full-width {
  width: 100%;
}

.image-reviews-container {
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  width: 113px;
  height: 65px;
  border-radius: 5px;

  .image {
    user-drag: none; /* Safari */
    -webkit-user-drag: none; /* Chrome, Safari, Edge */
    -moz-user-select: none; /* Firefox */
    user-select: none; /* Ngăn chọn ảnh */
    pointer-events: auto; /* Vẫn cho click */
    width: 100%;
    height: 100%;
    border-radius: 5px;
    object-fit: cover; /* giữ toàn bộ ảnh, không bị crop */
    object-position: center;
  }
}
.body-card {
  background-color: #fff;

  padding: 10px;
  display: flex;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
}

.text-left {
  width: 100%;
  text-align: left;
}

.mb-0 {
  margin-bottom: 0;
}
.facility-name {
  height: 37px;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Số dòng giới hạn */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 18px;
  margin: 0;
}
.des-facility {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Số dòng giới hạn */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 15px;
  margin: 0;
}
@media screen and (min-width: 0px) and (max-width: 480px) {
  .body-card {
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    margin-bottom: 10px;
    width: 238px;
    box-shadow: 0px 0px 4px 0px #00000026;
  }
}
</style>
